export default __webpack_public_path__ + "static/media/iconeTresPontinhos.dfd01409.svg";